/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import type { ChildEntitiesSearchRequest } from '../models/childEntitiesSearchRequest';
import type { CloneEntityBody } from '../models/cloneEntityBody';
import type { CloneEntityParams } from '../models/cloneEntityParams';
import type { DeployEntityParams } from '../models/deployEntityParams';
import type { Entity } from '../models/entity';
import type { EntityBulkFetchRequest } from '../models/entityBulkFetchRequest';
import type { EntityBulkFetchResponse } from '../models/entityBulkFetchResponse';
import type { EntityCopyRequest } from '../models/entityCopyRequest';
import type { EntityDependencyTree } from '../models/entityDependencyTree';
import type { EntityDistinctValuesRequest } from '../models/entityDistinctValuesRequest';
import type { EntityExportRequest } from '../models/entityExportRequest';
import type { EntityImportFieldMapping } from '../models/entityImportFieldMapping';
import type { EntityImportRequest } from '../models/entityImportRequest';
import type { EntityMutationResponse } from '../models/entityMutationResponse';
import type { GetDeployedEntitySnapshotParams } from '../models/getDeployedEntitySnapshotParams';
import type { GetEntitySnapshotParams } from '../models/getEntitySnapshotParams';
import type { GetLatestVersion200 } from '../models/getLatestVersion200';
import type { HierarchicalEntityMutationRequest } from '../models/hierarchicalEntityMutationRequest';
import type { HitsEntity1 } from '../models/hitsEntity1';
import type { ImportFieldMappingRequest } from '../models/importFieldMappingRequest';
import type { Query } from '../models/query';
import type { RestoreEntityParams } from '../models/restoreEntityParams';
import type { Update } from '../models/update';
import type { UpdateEntityByIdParams } from '../models/updateEntityByIdParams';
import { executeFetch } from '../../utils/fetch/fetch';
import type { ErrorType } from '../../utils/fetch/fetch';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Create Entity
 */
export const createEntity = (entity: Entity, options?: SecondParameter<typeof executeFetch>) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entity,
    },
    options,
  );
};

export const getCreateEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntity>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEntity>>, { data: Entity }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createEntity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createEntity>>>;
export type CreateEntityMutationBody = Entity;
export type CreateEntityMutationError = ErrorType<unknown>;

/**
 * @summary Create Entity
 */
export const useCreateEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntity>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions = getCreateEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Bulk Fetch Entities
 */
export const bulkFetchEntities = (
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<EntityBulkFetchResponse>(
    {
      url: `/api/entity/bulk-fetch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityBulkFetchRequest,
    },
    options,
  );
};

export const getBulkFetchEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkFetchEntities>>,
    TError,
    { data: EntityBulkFetchRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkFetchEntities>>,
  TError,
  { data: EntityBulkFetchRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkFetchEntities>>,
    { data: EntityBulkFetchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkFetchEntities(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkFetchEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkFetchEntities>>
>;
export type BulkFetchEntitiesMutationBody = EntityBulkFetchRequest;
export type BulkFetchEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Bulk Fetch Entities
 */
export const useBulkFetchEntities = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkFetchEntities>>,
    TError,
    { data: EntityBulkFetchRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkFetchEntities>>,
  TError,
  { data: EntityBulkFetchRequest },
  TContext
> => {
  const mutationOptions = getBulkFetchEntitiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Create Entity And Get Violations
 */
export const createEntityAndGetViolations = (
  entity: Entity,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<EntityMutationResponse>(
    {
      url: `/api/entity/checkAndCreate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entity,
    },
    options,
  );
};

export const getCreateEntityAndGetViolationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntityAndGetViolations>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntityAndGetViolations>>,
    { data: Entity }
  > = (props) => {
    const { data } = props ?? {};

    return createEntityAndGetViolations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityAndGetViolationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEntityAndGetViolations>>
>;
export type CreateEntityAndGetViolationsMutationBody = Entity;
export type CreateEntityAndGetViolationsMutationError = ErrorType<unknown>;

/**
 * @summary Create Entity And Get Violations
 */
export const useCreateEntityAndGetViolations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntityAndGetViolations>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions = getCreateEntityAndGetViolationsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Update Entity And Get Violations
 */
export const updateEntityAndGetViolations = (
  entity: Entity,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<EntityMutationResponse>(
    {
      url: `/api/entity/checkAndUpdate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entity,
    },
    options,
  );
};

export const getUpdateEntityAndGetViolationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
    { data: Entity }
  > = (props) => {
    const { data } = props ?? {};

    return updateEntityAndGetViolations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityAndGetViolationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEntityAndGetViolations>>
>;
export type UpdateEntityAndGetViolationsMutationBody = Entity;
export type UpdateEntityAndGetViolationsMutationError = ErrorType<unknown>;

/**
 * @summary Update Entity And Get Violations
 */
export const useUpdateEntityAndGetViolations = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEntityAndGetViolations>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions = getUpdateEntityAndGetViolationsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Search Dependent Entities
 */
export const searchChildEntities = (
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/child-entities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: childEntitiesSearchRequest,
    },
    options,
  );
};

export const getSearchChildEntitiesQueryKey = (
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
) => {
  return [`/api/entity/child-entities`, childEntitiesSearchRequest] as const;
};

export const getSearchChildEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchChildEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchChildEntitiesQueryKey(childEntitiesSearchRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchChildEntities>>> = ({ meta }) =>
    searchChildEntities(childEntitiesSearchRequest, { ...requestOptions, meta });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchChildEntities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchChildEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchChildEntities>>
>;
export type SearchChildEntitiesQueryError = ErrorType<unknown>;

/**
 * @summary Search Dependent Entities
 */
export const useSearchChildEntities = <
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchChildEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchChildEntitiesQueryOptions(childEntitiesSearchRequest, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Search Dependent Entities
 */
export const prefetchSearchChildEntities = async <
  TData = Awaited<ReturnType<typeof searchChildEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchChildEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchChildEntitiesQueryOptions(childEntitiesSearchRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Clone Entity
 */
export const cloneEntity = (
  entityType: string,
  entityId: string,
  cloneEntityBody: CloneEntityBody,
  params?: CloneEntityParams,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/clone/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: cloneEntityBody,
      params,
    },
    options,
  );
};

export const getCloneEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneEntity>>,
    TError,
    { entityType: string; entityId: string; data: CloneEntityBody; params?: CloneEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneEntity>>,
  TError,
  { entityType: string; entityId: string; data: CloneEntityBody; params?: CloneEntityParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneEntity>>,
    { entityType: string; entityId: string; data: CloneEntityBody; params?: CloneEntityParams }
  > = (props) => {
    const { entityType, entityId, data, params } = props ?? {};

    return cloneEntity(entityType, entityId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloneEntityMutationResult = NonNullable<Awaited<ReturnType<typeof cloneEntity>>>;
export type CloneEntityMutationBody = CloneEntityBody;
export type CloneEntityMutationError = ErrorType<unknown>;

/**
 * @summary Clone Entity
 */
export const useCloneEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneEntity>>,
    TError,
    { entityType: string; entityId: string; data: CloneEntityBody; params?: CloneEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cloneEntity>>,
  TError,
  { entityType: string; entityId: string; data: CloneEntityBody; params?: CloneEntityParams },
  TContext
> => {
  const mutationOptions = getCloneEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Copy Entity
 */
export const copyEntity = (
  entityCopyRequest: EntityCopyRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/copyEntity`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityCopyRequest,
    },
    options,
  );
};

export const getCopyEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyEntity>>,
    TError,
    { data: EntityCopyRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyEntity>>,
  TError,
  { data: EntityCopyRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyEntity>>,
    { data: EntityCopyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return copyEntity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyEntityMutationResult = NonNullable<Awaited<ReturnType<typeof copyEntity>>>;
export type CopyEntityMutationBody = EntityCopyRequest;
export type CopyEntityMutationError = ErrorType<unknown>;

/**
 * @summary Copy Entity
 */
export const useCopyEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyEntity>>,
    TError,
    { data: EntityCopyRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof copyEntity>>,
  TError,
  { data: EntityCopyRequest },
  TContext
> => {
  const mutationOptions = getCopyEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Create Hierarchical Entity
 */
export const createUpdateOrDeleteHierarchicalEntity = (
  hierarchicalEntityMutationRequest: HierarchicalEntityMutationRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<Entity[]>(
    {
      url: `/api/entity/create-update-or-delete/hierarchical`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: hierarchicalEntityMutationRequest,
    },
    options,
  );
};

export const getCreateUpdateOrDeleteHierarchicalEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
    TError,
    { data: HierarchicalEntityMutationRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
  TError,
  { data: HierarchicalEntityMutationRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
    { data: HierarchicalEntityMutationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createUpdateOrDeleteHierarchicalEntity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUpdateOrDeleteHierarchicalEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>
>;
export type CreateUpdateOrDeleteHierarchicalEntityMutationBody = HierarchicalEntityMutationRequest;
export type CreateUpdateOrDeleteHierarchicalEntityMutationError = ErrorType<unknown>;

/**
 * @summary Create Hierarchical Entity
 */
export const useCreateUpdateOrDeleteHierarchicalEntity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
    TError,
    { data: HierarchicalEntityMutationRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUpdateOrDeleteHierarchicalEntity>>,
  TError,
  { data: HierarchicalEntityMutationRequest },
  TContext
> => {
  const mutationOptions = getCreateUpdateOrDeleteHierarchicalEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Bulk Fetch Deployed Entities
 */
export const deployedBulkFetchEntities = (
  entityBulkFetchRequest: EntityBulkFetchRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<EntityBulkFetchResponse>(
    {
      url: `/api/entity/deployed/bulk-fetch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityBulkFetchRequest,
    },
    options,
  );
};

export const getDeployedBulkFetchEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
    TError,
    { data: EntityBulkFetchRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
  TError,
  { data: EntityBulkFetchRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
    { data: EntityBulkFetchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return deployedBulkFetchEntities(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeployedBulkFetchEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deployedBulkFetchEntities>>
>;
export type DeployedBulkFetchEntitiesMutationBody = EntityBulkFetchRequest;
export type DeployedBulkFetchEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Bulk Fetch Deployed Entities
 */
export const useDeployedBulkFetchEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
    TError,
    { data: EntityBulkFetchRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deployedBulkFetchEntities>>,
  TError,
  { data: EntityBulkFetchRequest },
  TContext
> => {
  const mutationOptions = getDeployedBulkFetchEntitiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Search Dependent Deployed Entities
 */
export const searchDeployedChildEntities = (
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/child-entities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: childEntitiesSearchRequest,
    },
    options,
  );
};

export const getSearchDeployedChildEntitiesQueryKey = (
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
) => {
  return [`/api/entity/deployed/child-entities`, childEntitiesSearchRequest] as const;
};

export const getSearchDeployedChildEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchDeployedChildEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchDeployedChildEntitiesQueryKey(childEntitiesSearchRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDeployedChildEntities>>> = ({
    meta,
  }) => searchDeployedChildEntities(childEntitiesSearchRequest, { ...requestOptions, meta });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedChildEntities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchDeployedChildEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedChildEntities>>
>;
export type SearchDeployedChildEntitiesQueryError = ErrorType<unknown>;

/**
 * @summary Search Dependent Deployed Entities
 */
export const useSearchDeployedChildEntities = <
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchDeployedChildEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchDeployedChildEntitiesQueryOptions(
    childEntitiesSearchRequest,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Search Dependent Deployed Entities
 */
export const prefetchSearchDeployedChildEntities = async <
  TData = Awaited<ReturnType<typeof searchDeployedChildEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  childEntitiesSearchRequest: ChildEntitiesSearchRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchDeployedChildEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedChildEntitiesQueryOptions(
    childEntitiesSearchRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const getDeployedEntityDependencyTree = (
  entityType: string,
  entityId: string,
  version: number,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependencyTree>(
    {
      url: `/api/entity/deployed/entity-dependents/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetDeployedEntityDependencyTreeQueryKey = (
  entityType: string,
  entityId: string,
  version: number,
) => {
  return [`/api/entity/deployed/entity-dependents/${entityType}/${entityId}/${version}`] as const;
};

export const getGetDeployedEntityDependencyTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDeployedEntityDependencyTreeQueryKey(entityType, entityId, version);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>> = ({
    signal,
    meta,
  }) =>
    getDeployedEntityDependencyTree(
      entityType,
      entityId,
      version,
      { ...requestOptions, meta },
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId && version),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDeployedEntityDependencyTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>
>;
export type GetDeployedEntityDependencyTreeQueryError = ErrorType<unknown>;

/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const useGetDeployedEntityDependencyTree = <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDeployedEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Deployed Entity Dependency Tree
 */
export const prefetchGetDeployedEntityDependencyTree = async <
  TData = Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntityDependencyTree>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDeployedEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Deployed Entity Snapshot
 */
export const getDeployedEntitySnapshot = (
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/snapshot/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetDeployedEntitySnapshotQueryKey = (
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
) => {
  return [
    `/api/entity/deployed/snapshot/${entityType}/${entityId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDeployedEntitySnapshotQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntitySnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeployedEntitySnapshotQueryKey(entityType, entityId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeployedEntitySnapshot>>> = ({
    signal,
    meta,
  }) =>
    getDeployedEntitySnapshot(entityType, entityId, params, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntitySnapshot>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetDeployedEntitySnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeployedEntitySnapshot>>
>;
export type GetDeployedEntitySnapshotQueryError = ErrorType<unknown>;

/**
 * @summary Get Deployed Entity Snapshot
 */
export const useGetDeployedEntitySnapshot = <
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntitySnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDeployedEntitySnapshotQueryOptions(
    entityType,
    entityId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Deployed Entity Snapshot
 */
export const prefetchGetDeployedEntitySnapshot = async <
  TData = Awaited<ReturnType<typeof getDeployedEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  params?: GetDeployedEntitySnapshotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDeployedEntitySnapshot>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDeployedEntitySnapshotQueryOptions(
    entityType,
    entityId,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Entities
 */
export const searchDeployedEntities = (
  entityType: string,
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/deployed/${encodeURIComponent(String(entityType))}/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: query,
    },
    options,
  );
};

export const getSearchDeployedEntitiesQueryKey = (entityType: string, query: Query) => {
  return [`/api/entity/deployed/${entityType}/search`, query] as const;
};

export const getSearchDeployedEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchDeployedEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchDeployedEntitiesQueryKey(entityType, query);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDeployedEntities>>> = ({ meta }) =>
    searchDeployedEntities(entityType, query, { ...requestOptions, meta });

  return { queryKey, queryFn, enabled: !!entityType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDeployedEntities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchDeployedEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDeployedEntities>>
>;
export type SearchDeployedEntitiesQueryError = ErrorType<unknown>;

/**
 * @summary Search Deployed Entities
 */
export const useSearchDeployedEntities = <
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchDeployedEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchDeployedEntitiesQueryOptions(entityType, query, options);

  const _query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  _query.queryKey = queryOptions.queryKey;

  return _query;
};

/**
 * @summary Search Deployed Entities
 */
export const prefetchSearchDeployedEntities = async <
  TData = Awaited<ReturnType<typeof searchDeployedEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchDeployedEntities>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchDeployedEntitiesQueryOptions(entityType, query, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Deployed Entity By Id
 */
export const findDeployedEntityById = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/deployed/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getFindDeployedEntityByIdQueryKey = (entityType: string, entityId: string) => {
  return [`/api/entity/deployed/${entityType}/${entityId}`] as const;
};

export const getFindDeployedEntityByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findDeployedEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindDeployedEntityByIdQueryKey(entityType, entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findDeployedEntityById>>> = ({
    signal,
    meta,
  }) => findDeployedEntityById(entityType, entityId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof findDeployedEntityById>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type FindDeployedEntityByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof findDeployedEntityById>>
>;
export type FindDeployedEntityByIdQueryError = ErrorType<unknown>;

/**
 * @summary Find Deployed Entity By Id
 */
export const useFindDeployedEntityById = <
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findDeployedEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindDeployedEntityByIdQueryOptions(entityType, entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Find Deployed Entity By Id
 */
export const prefetchFindDeployedEntityById = async <
  TData = Awaited<ReturnType<typeof findDeployedEntityById>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findDeployedEntityById>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindDeployedEntityByIdQueryOptions(entityType, entityId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Distinct Values
 */
export const getDistinctValues = (
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/distinct-values`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityDistinctValuesRequest,
    },
    options,
  );
};

export const getGetDistinctValuesQueryKey = (
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
) => {
  return [`/api/entity/distinct-values`, entityDistinctValuesRequest] as const;
};

export const getGetDistinctValuesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistinctValues>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDistinctValuesQueryKey(entityDistinctValuesRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDistinctValues>>> = ({ meta }) =>
    getDistinctValues(entityDistinctValuesRequest, { ...requestOptions, meta });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDistinctValues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDistinctValuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDistinctValues>>
>;
export type GetDistinctValuesQueryError = ErrorType<unknown>;

/**
 * @summary Get Distinct Values
 */
export const useGetDistinctValues = <
  TData = Awaited<ReturnType<typeof getDistinctValues>>,
  TError = ErrorType<unknown>,
>(
  entityDistinctValuesRequest: EntityDistinctValuesRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistinctValues>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDistinctValuesQueryOptions(entityDistinctValuesRequest, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Entity Dependency Tree
 */
export const getEntityDependencyTree = (
  entityType: string,
  entityId: string,
  version: number,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<EntityDependencyTree>(
    {
      url: `/api/entity/entity-dependents/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetEntityDependencyTreeQueryKey = (
  entityType: string,
  entityId: string,
  version: number,
) => {
  return [`/api/entity/entity-dependents/${entityType}/${entityId}/${version}`] as const;
};

export const getGetEntityDependencyTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntityDependencyTree>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntityDependencyTreeQueryKey(entityType, entityId, version);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntityDependencyTree>>> = ({
    signal,
    meta,
  }) => getEntityDependencyTree(entityType, entityId, version, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId && version),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEntityDependencyTree>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetEntityDependencyTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntityDependencyTree>>
>;
export type GetEntityDependencyTreeQueryError = ErrorType<unknown>;

/**
 * @summary Get Entity Dependency Tree
 */
export const useGetEntityDependencyTree = <
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntityDependencyTree>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Entity Dependency Tree
 */
export const prefetchGetEntityDependencyTree = async <
  TData = Awaited<ReturnType<typeof getEntityDependencyTree>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  version: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntityDependencyTree>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetEntityDependencyTreeQueryOptions(
    entityType,
    entityId,
    version,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Export Entities
 */
export const exportEntities = (
  entityExportRequest: EntityExportRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<string>(
    {
      url: `/api/entity/exportEntities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityExportRequest,
    },
    options,
  );
};

export const getExportEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportEntities>>,
    TError,
    { data: EntityExportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exportEntities>>,
  TError,
  { data: EntityExportRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exportEntities>>,
    { data: EntityExportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return exportEntities(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExportEntitiesMutationResult = NonNullable<Awaited<ReturnType<typeof exportEntities>>>;
export type ExportEntitiesMutationBody = EntityExportRequest;
export type ExportEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Export Entities
 */
export const useExportEntities = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exportEntities>>,
    TError,
    { data: EntityExportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exportEntities>>,
  TError,
  { data: EntityExportRequest },
  TContext
> => {
  const mutationOptions = getExportEntitiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get Import Field Mapping
 */
export const getImportFieldMapping = (
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<EntityImportFieldMapping[]>(
    {
      url: `/api/entity/getImportFieldMapping`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: importFieldMappingRequest,
    },
    options,
  );
};

export const getGetImportFieldMappingQueryKey = (
  importFieldMappingRequest: ImportFieldMappingRequest,
) => {
  return [`/api/entity/getImportFieldMapping`, importFieldMappingRequest] as const;
};

export const getGetImportFieldMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImportFieldMapping>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetImportFieldMappingQueryKey(importFieldMappingRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportFieldMapping>>> = ({ meta }) =>
    getImportFieldMapping(importFieldMappingRequest, { ...requestOptions, meta });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImportFieldMapping>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetImportFieldMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImportFieldMapping>>
>;
export type GetImportFieldMappingQueryError = ErrorType<unknown>;

/**
 * @summary Get Import Field Mapping
 */
export const useGetImportFieldMapping = <
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImportFieldMapping>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetImportFieldMappingQueryOptions(importFieldMappingRequest, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Import Field Mapping
 */
export const prefetchGetImportFieldMapping = async <
  TData = Awaited<ReturnType<typeof getImportFieldMapping>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  importFieldMappingRequest: ImportFieldMappingRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getImportFieldMapping>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetImportFieldMappingQueryOptions(importFieldMappingRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Import Entities
 */
export const importEntities = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/importEntities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityImportRequest,
    },
    options,
  );
};

export const getImportEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importEntities>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importEntities>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importEntities>>,
    { data: EntityImportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return importEntities(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportEntitiesMutationResult = NonNullable<Awaited<ReturnType<typeof importEntities>>>;
export type ImportEntitiesMutationBody = EntityImportRequest;
export type ImportEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Import Entities
 */
export const useImportEntities = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importEntities>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importEntities>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getImportEntitiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get Latest Version
 */
export const getLatestVersion = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<GetLatestVersion200>(
    {
      url: `/api/entity/latest-version/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetLatestVersionQueryKey = (entityType: string, entityId: string) => {
  return [`/api/entity/latest-version/${entityType}/${entityId}`] as const;
};

export const getGetLatestVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestVersion>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestVersionQueryKey(entityType, entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestVersion>>> = ({ signal, meta }) =>
    getLatestVersion(entityType, entityId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLatestVersion>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetLatestVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestVersion>>>;
export type GetLatestVersionQueryError = ErrorType<unknown>;

/**
 * @summary Get Latest Version
 */
export const useGetLatestVersion = <
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestVersion>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLatestVersionQueryOptions(entityType, entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Latest Version
 */
export const prefetchGetLatestVersion = async <
  TData = Awaited<ReturnType<typeof getLatestVersion>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestVersion>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetLatestVersionQueryOptions(entityType, entityId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Mutate Entity Id
 */
export const mutateEntityId = (
  entityType: string,
  existingEntityId: string,
  newEntityId: string,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/mutateEntityId/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(existingEntityId))}/${encodeURIComponent(String(newEntityId))}`,
      method: 'POST',
    },
    options,
  );
};

export const getMutateEntityIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mutateEntityId>>,
    TError,
    { entityType: string; existingEntityId: string; newEntityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mutateEntityId>>,
  TError,
  { entityType: string; existingEntityId: string; newEntityId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mutateEntityId>>,
    { entityType: string; existingEntityId: string; newEntityId: string }
  > = (props) => {
    const { entityType, existingEntityId, newEntityId } = props ?? {};

    return mutateEntityId(entityType, existingEntityId, newEntityId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MutateEntityIdMutationResult = NonNullable<Awaited<ReturnType<typeof mutateEntityId>>>;

export type MutateEntityIdMutationError = ErrorType<unknown>;

/**
 * @summary Mutate Entity Id
 */
export const useMutateEntityId = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mutateEntityId>>,
    TError,
    { entityType: string; existingEntityId: string; newEntityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mutateEntityId>>,
  TError,
  { entityType: string; existingEntityId: string; newEntityId: string },
  TContext
> => {
  const mutationOptions = getMutateEntityIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Parse Column
 */
export const parseColumn = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<string[]>(
    {
      url: `/api/entity/parseColumn`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityImportRequest,
    },
    options,
  );
};

export const getParseColumnMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumn>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseColumn>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseColumn>>,
    { data: EntityImportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return parseColumn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseColumnMutationResult = NonNullable<Awaited<ReturnType<typeof parseColumn>>>;
export type ParseColumnMutationBody = EntityImportRequest;
export type ParseColumnMutationError = ErrorType<unknown>;

/**
 * @summary Parse Column
 */
export const useParseColumn = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumn>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof parseColumn>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getParseColumnMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Parse Column Names
 */
export const parseColumnNames = (
  entityImportRequest: EntityImportRequest,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<string[]>(
    {
      url: `/api/entity/parseColumnNames`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entityImportRequest,
    },
    options,
  );
};

export const getParseColumnNamesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumnNames>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof parseColumnNames>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof parseColumnNames>>,
    { data: EntityImportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return parseColumnNames(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ParseColumnNamesMutationResult = NonNullable<
  Awaited<ReturnType<typeof parseColumnNames>>
>;
export type ParseColumnNamesMutationBody = EntityImportRequest;
export type ParseColumnNamesMutationError = ErrorType<unknown>;

/**
 * @summary Parse Column Names
 */
export const useParseColumnNames = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof parseColumnNames>>,
    TError,
    { data: EntityImportRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof parseColumnNames>>,
  TError,
  { data: EntityImportRequest },
  TContext
> => {
  const mutationOptions = getParseColumnNamesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Restore Entity From Deployed
 */
export const restoreEntityFromDeployed = (
  entityType: string,
  entityId: string,
  version: number,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/restore/deployed/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: 'POST',
    },
    options,
  );
};

export const getRestoreEntityFromDeployedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
    TError,
    { entityType: string; entityId: string; version: number },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
  TError,
  { entityType: string; entityId: string; version: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
    { entityType: string; entityId: string; version: number }
  > = (props) => {
    const { entityType, entityId, version } = props ?? {};

    return restoreEntityFromDeployed(entityType, entityId, version, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreEntityFromDeployedMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreEntityFromDeployed>>
>;

export type RestoreEntityFromDeployedMutationError = ErrorType<unknown>;

/**
 * @summary Restore Entity From Deployed
 */
export const useRestoreEntityFromDeployed = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
    TError,
    { entityType: string; entityId: string; version: number },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreEntityFromDeployed>>,
  TError,
  { entityType: string; entityId: string; version: number },
  TContext
> => {
  const mutationOptions = getRestoreEntityFromDeployedMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Restore Entity
 */
export const restoreEntity = (
  entityType: string,
  entityId: string,
  version: number,
  params?: RestoreEntityParams,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/restore/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/${encodeURIComponent(String(version))}`,
      method: 'POST',
      params,
    },
    options,
  );
};

export const getRestoreEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEntity>>,
    TError,
    { entityType: string; entityId: string; version: number; params?: RestoreEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreEntity>>,
  TError,
  { entityType: string; entityId: string; version: number; params?: RestoreEntityParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreEntity>>,
    { entityType: string; entityId: string; version: number; params?: RestoreEntityParams }
  > = (props) => {
    const { entityType, entityId, version, params } = props ?? {};

    return restoreEntity(entityType, entityId, version, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreEntityMutationResult = NonNullable<Awaited<ReturnType<typeof restoreEntity>>>;

export type RestoreEntityMutationError = ErrorType<unknown>;

/**
 * @summary Restore Entity
 */
export const useRestoreEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreEntity>>,
    TError,
    { entityType: string; entityId: string; version: number; params?: RestoreEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreEntity>>,
  TError,
  { entityType: string; entityId: string; version: number; params?: RestoreEntityParams },
  TContext
> => {
  const mutationOptions = getRestoreEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Search Entity Snapshot
 */
export const searchEntitySnapshot = (
  entityType: string,
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/snapshot/${encodeURIComponent(String(entityType))}/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: query,
    },
    options,
  );
};

export const getSearchEntitySnapshotMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchEntitySnapshot>>,
    TError,
    { entityType: string; data: Query },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchEntitySnapshot>>,
  TError,
  { entityType: string; data: Query },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchEntitySnapshot>>,
    { entityType: string; data: Query }
  > = (props) => {
    const { entityType, data } = props ?? {};

    return searchEntitySnapshot(entityType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchEntitySnapshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchEntitySnapshot>>
>;
export type SearchEntitySnapshotMutationBody = Query;
export type SearchEntitySnapshotMutationError = ErrorType<unknown>;

/**
 * @summary Search Entity Snapshot
 */
export const useSearchEntitySnapshot = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchEntitySnapshot>>,
    TError,
    { entityType: string; data: Query },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchEntitySnapshot>>,
  TError,
  { entityType: string; data: Query },
  TContext
> => {
  const mutationOptions = getSearchEntitySnapshotMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get Entity Snapshot
 */
export const getEntitySnapshot = (
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/snapshot/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetEntitySnapshotQueryKey = (
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
) => {
  return [`/api/entity/snapshot/${entityType}/${entityId}`, ...(params ? [params] : [])] as const;
};

export const getGetEntitySnapshotQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitySnapshot>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntitySnapshotQueryKey(entityType, entityId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntitySnapshot>>> = ({
    signal,
    meta,
  }) => getEntitySnapshot(entityType, entityId, params, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEntitySnapshot>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetEntitySnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntitySnapshot>>
>;
export type GetEntitySnapshotQueryError = ErrorType<unknown>;

/**
 * @summary Get Entity Snapshot
 */
export const useGetEntitySnapshot = <
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitySnapshot>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetEntitySnapshotQueryOptions(entityType, entityId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Entity Snapshot
 */
export const prefetchGetEntitySnapshot = async <
  TData = Awaited<ReturnType<typeof getEntitySnapshot>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  params?: GetEntitySnapshotParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntitySnapshot>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetEntitySnapshotQueryOptions(entityType, entityId, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update Entity
 */
export const updateEntity = (entity: Entity, options?: SecondParameter<typeof executeFetch>) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/update`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entity,
    },
    options,
  );
};

export const getUpdateEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntity>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEntity>>, { data: Entity }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return updateEntity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateEntity>>>;
export type UpdateEntityMutationBody = Entity;
export type UpdateEntityMutationError = ErrorType<unknown>;

/**
 * @summary Update Entity
 */
export const useUpdateEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntity>>,
    TError,
    { data: Entity },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEntity>>,
  TError,
  { data: Entity },
  TContext
> => {
  const mutationOptions = getUpdateEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Search Entities
 */
export const searchEntities = (
  entityType: string,
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: query,
    },
    options,
  );
};

export const getSearchEntitiesQueryKey = (entityType: string, query: Query) => {
  return [`/api/entity/${entityType}`, query] as const;
};

export const getSearchEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchEntitiesQueryKey(entityType, query);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEntities>>> = ({ meta }) =>
    searchEntities(entityType, query, { ...requestOptions, meta });

  return { queryKey, queryFn, enabled: !!entityType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchEntities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof searchEntities>>>;
export type SearchEntitiesQueryError = ErrorType<unknown>;

/**
 * @summary Search Entities
 */
export const useSearchEntities = <
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getSearchEntitiesQueryOptions(entityType, query, options);

  const _query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  _query.queryKey = queryOptions.queryKey;

  return _query;
};

/**
 * @summary Search Entities
 */
export const prefetchSearchEntities = async <
  TData = Awaited<ReturnType<typeof searchEntities>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  query: Query,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEntities>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSearchEntitiesQueryOptions(entityType, query, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Archive Entity
 */
export const archiveEntity = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/archive/${encodeURIComponent(String(entityId))}`,
      method: 'POST',
    },
    options,
  );
};

export const getArchiveEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveEntity>>,
    { entityType: string; entityId: string }
  > = (props) => {
    const { entityType, entityId } = props ?? {};

    return archiveEntity(entityType, entityId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveEntityMutationResult = NonNullable<Awaited<ReturnType<typeof archiveEntity>>>;

export type ArchiveEntityMutationError = ErrorType<unknown>;

/**
 * @summary Archive Entity
 */
export const useArchiveEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getArchiveEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Delete Dependent Entities
 */
export const deleteDependentEntities = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/delete-dependents/${encodeURIComponent(String(entityId))}`,
      method: 'POST',
    },
    options,
  );
};

export const getDeleteDependentEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDependentEntities>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDependentEntities>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDependentEntities>>,
    { entityType: string; entityId: string }
  > = (props) => {
    const { entityType, entityId } = props ?? {};

    return deleteDependentEntities(entityType, entityId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDependentEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDependentEntities>>
>;

export type DeleteDependentEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Delete Dependent Entities
 */
export const useDeleteDependentEntities = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDependentEntities>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDependentEntities>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getDeleteDependentEntitiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Delete Entity
 */
export const deleteEntity = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/delete/${encodeURIComponent(String(entityId))}`,
      method: 'POST',
    },
    options,
  );
};

export const getDeleteEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEntity>>,
    { entityType: string; entityId: string }
  > = (props) => {
    const { entityType, entityId } = props ?? {};

    return deleteEntity(entityType, entityId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEntityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntity>>>;

export type DeleteEntityMutationError = ErrorType<unknown>;

/**
 * @summary Delete Entity
 */
export const useDeleteEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getDeleteEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Save Bulk Entities
 */
export const saveBulkEntities = (
  entityType: string,
  entity: Entity[],
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<unknown[]>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/saveBulkEntities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: entity,
    },
    options,
  );
};

export const getSaveBulkEntitiesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBulkEntities>>,
    TError,
    { entityType: string; data: Entity[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveBulkEntities>>,
  TError,
  { entityType: string; data: Entity[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveBulkEntities>>,
    { entityType: string; data: Entity[] }
  > = (props) => {
    const { entityType, data } = props ?? {};

    return saveBulkEntities(entityType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveBulkEntitiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveBulkEntities>>
>;
export type SaveBulkEntitiesMutationBody = Entity[];
export type SaveBulkEntitiesMutationError = ErrorType<unknown>;

/**
 * @summary Save Bulk Entities
 */
export const useSaveBulkEntities = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBulkEntities>>,
    TError,
    { entityType: string; data: Entity[] },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveBulkEntities>>,
  TError,
  { entityType: string; data: Entity[] },
  TContext
> => {
  const mutationOptions = getSaveBulkEntitiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Unarchive Entity
 */
export const unarchiveEntity = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/unarchive/${encodeURIComponent(String(entityId))}`,
      method: 'POST',
    },
    options,
  );
};

export const getUnarchiveEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unarchiveEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unarchiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unarchiveEntity>>,
    { entityType: string; entityId: string }
  > = (props) => {
    const { entityType, entityId } = props ?? {};

    return unarchiveEntity(entityType, entityId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnarchiveEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveEntity>>
>;

export type UnarchiveEntityMutationError = ErrorType<unknown>;

/**
 * @summary Unarchive Entity
 */
export const useUnarchiveEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unarchiveEntity>>,
    TError,
    { entityType: string; entityId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unarchiveEntity>>,
  TError,
  { entityType: string; entityId: string },
  TContext
> => {
  const mutationOptions = getUnarchiveEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Update Entity
 */
export const updateEntityById = (
  entityType: string,
  entityId: string,
  update: Update,
  params?: UpdateEntityByIdParams,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<void>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/update/${encodeURIComponent(String(entityId))}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: update,
      params,
    },
    options,
  );
};

export const getUpdateEntityByIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntityById>>,
    TError,
    { entityType: string; entityId: string; data: Update; params?: UpdateEntityByIdParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntityById>>,
  TError,
  { entityType: string; entityId: string; data: Update; params?: UpdateEntityByIdParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEntityById>>,
    { entityType: string; entityId: string; data: Update; params?: UpdateEntityByIdParams }
  > = (props) => {
    const { entityType, entityId, data, params } = props ?? {};

    return updateEntityById(entityType, entityId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEntityById>>
>;
export type UpdateEntityByIdMutationBody = Update;
export type UpdateEntityByIdMutationError = ErrorType<unknown>;

/**
 * @summary Update Entity
 */
export const useUpdateEntityById = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntityById>>,
    TError,
    { entityType: string; entityId: string; data: Update; params?: UpdateEntityByIdParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEntityById>>,
  TError,
  { entityType: string; entityId: string; data: Update; params?: UpdateEntityByIdParams },
  TContext
> => {
  const mutationOptions = getUpdateEntityByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Find Entity By Id
 */
export const findEntityById = (
  entityType: string,
  entityId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<Entity>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getFindEntityByIdQueryKey = (entityType: string, entityId: string) => {
  return [`/api/entity/${entityType}/${entityId}`] as const;
};

export const getFindEntityByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindEntityByIdQueryKey(entityType, entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findEntityById>>> = ({ signal, meta }) =>
    findEntityById(entityType, entityId, { ...requestOptions, meta }, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(entityType && entityId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type FindEntityByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findEntityById>>>;
export type FindEntityByIdQueryError = ErrorType<unknown>;

/**
 * @summary Find Entity By Id
 */
export const useFindEntityById = <
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getFindEntityByIdQueryOptions(entityType, entityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Find Entity By Id
 */
export const prefetchFindEntityById = async <
  TData = Awaited<ReturnType<typeof findEntityById>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  entityType: string,
  entityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findEntityById>>, TError, TData>>;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindEntityByIdQueryOptions(entityType, entityId, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Search Deployed Entities
 */
export const deployEntity = (
  entityType: string,
  entityId: string,
  params?: DeployEntityParams,
  options?: SecondParameter<typeof executeFetch>,
) => {
  return executeFetch<HitsEntity1>(
    {
      url: `/api/entity/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/deploy`,
      method: 'POST',
      params,
    },
    options,
  );
};

export const getDeployEntityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployEntity>>,
    TError,
    { entityType: string; entityId: string; params?: DeployEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deployEntity>>,
  TError,
  { entityType: string; entityId: string; params?: DeployEntityParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deployEntity>>,
    { entityType: string; entityId: string; params?: DeployEntityParams }
  > = (props) => {
    const { entityType, entityId, params } = props ?? {};

    return deployEntity(entityType, entityId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeployEntityMutationResult = NonNullable<Awaited<ReturnType<typeof deployEntity>>>;

export type DeployEntityMutationError = ErrorType<unknown>;

/**
 * @summary Search Deployed Entities
 */
export const useDeployEntity = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deployEntity>>,
    TError,
    { entityType: string; entityId: string; params?: DeployEntityParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deployEntity>>,
  TError,
  { entityType: string; entityId: string; params?: DeployEntityParams },
  TContext
> => {
  const mutationOptions = getDeployEntityMutationOptions(options);

  return useMutation(mutationOptions);
};
